








































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import {
  InsertEducationPlan,
  UpdateEducationPlan
} from "@/api/pdEducationPlan/pdEducationPlan";
@Component({})
export default class PdEducationPlanAdd extends AbpBase {
  @Prop() pdEducaionPlan: any;
  @Prop({ type: Boolean, default: false }) value: boolean;
  EducationPlan: any = {};
  loading: boolean = false;
  rules = {
    title: [
      {
        required: true,
        type: "string",
        message: "计划名称不能为空",
        trigger: "change"
      }
    ],
    description: [
      {
        required: true,
        type: "string",
        message: "计划说明",
        trigger: "change"
      }
    ]
  };

  created() {
    if (this.pdEducaionPlan) {
      this.EducationPlan = Object.assign({}, this.pdEducaionPlan);
    }
  }
  /*   @Watch("pdEducaionPlan", { immediate: false, deep: true })
  onGetEducationPlan() {
    if (this.pdEducaionPlan) {
      console.log(this.pdEducaionPlan);
      this.EducationPlan = this.pdEducaionPlan;
    }
  }
 */
  async save() {
    let validResult = false;
    console.log('123');
    this.$refs["form"].validate(valid => {
      if (valid) {
        validResult = true;
      }
    });
    if (validResult) {
      let res;
      if (this.EducationPlan.id > 0) {
        res = await UpdateEducationPlan(this.EducationPlan);
      } else {
        res = await InsertEducationPlan(this.EducationPlan);
      }
      this.$emit("input", false);
      this.$emit("on-success");
    }
  }
  constructor() {
    super();
  }
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdEducationPlan/parts/pdEducationPlan/pdEducationPlanAdd.vue